<template>
    <div class="flex flex-col items-center justify-center gap-4">
        <BlendedCircles class="max-w-120" />
        <p class="display-serif">{{ mainLoadingMessage }}</p>
        <Transition v-if="!hideMessages" name="slide" mode="out-in">
            <p :key="currentMessageShown" class="text-valence-primary-500 scaffold-body">{{ currentMessageShown }}</p>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { useIntervalFn } from "@vueuse/core";
import { computed, onUnmounted, ref } from "vue";

import BlendedCircles from "../BlendedCircles.vue";

type LoadingStepProps = {
    mainLoadingMessage?: string;
    hasPerspective?: boolean;
    hideMessages?: boolean;
};

const { mainLoadingMessage = "Building your collaboration profile", hasPerspective = false, hideMessages = false } = defineProps<LoadingStepProps>();

const messages = computed(() => {
    const msgArr = ["Analyzing how you collaborate...", "Tailoring guidance for your teammates...", "Crafting your personalized profile..."];
    if (hasPerspective) {
        msgArr.push("Importing your context from Perspective...");
    }
    return msgArr;
});
let messageIndex = 0;
const currentMessageShown = ref(messages.value[0]);

const { pause } = useIntervalFn(() => {
    messageIndex = (messageIndex + 1) % messages.value.length;
    currentMessageShown.value = messages.value[messageIndex]!;
}, 1500);

onUnmounted(() => {
    pause();
});
</script>

<style scoped>
.slide-leave-active,
.slide-enter-active {
    transition: all 300ms ease-out;
}

.slide-leave-from,
.slide-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.slide-enter-from {
    opacity: 0;
    transform: translateY(-0.5lh);
}
.slide-leave-to {
    opacity: 0;
    transform: translateY(0.5lh);
}
</style>
